// Port of pumppu_calcKestoFromM3 (puminet4/src/data/keikka/pumppuFunctions.jsx).
// Returns the estimated pump duration as a decimal-hours string, or "" if m3 is invalid.

export function calcKestoHoursFromM3(m3) {
    const m3num = Number(m3);
    if (!m3num || m3num <= 0) return "";
    const minutes = Math.round((0.945 * Math.pow(m3num, 0.5068) * 60) / 15) * 15;
    return String(minutes / 60);
}

// Toimittajakohtainen varmistussääntö (ei yleinen betonialan standardi):
// kun erillistä lisälinjaa on yli 7 m, käytössä oleva hand-line ei vedä
// luotettavasti 16 mm tai 32 mm raekokoa — vain 8 mm tai "16 mm hieno"
// jää pumpattavaksi. BLY-ohjeistus rajaa raekoon ensisijaisesti linjan
// halkaisijan kautta; tämä cutoff on operatiivinen guard. Empty / "En tiedä"
// raekoko aina sallittu (operaattori päättää).
import { RAE_KOKO_IDS_FORBIDDEN_ON_LONG_LINE } from "./quoteConstants";

export const PUMP_LINE_RAEKOKO_LIMIT_M = 7;

export function isRaekokoForbiddenByLine(raeKokoId, linjanPituus) {
    const line = Number(linjanPituus) || 0;
    if (line <= PUMP_LINE_RAEKOKO_LIMIT_M) return false;
    return RAE_KOKO_IDS_FORBIDDEN_ON_LONG_LINE.includes(raeKokoId);
}
